import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="order-1 md:order-1">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20home%20office%20corner%20with%20laptop%20on%20sage%20green%20desk%20displaying%20colorful%20spreadsheet%2C%20ceramic%20coffee%20mug%20potted%20monstera%20plant%20and%20a%20single%20pair%20of%20tan%20leather%20loafers%20beside%20the%20laptop%2C%20warm%20afternoon%20sunlight%20through%20sheer%20linen%20curtains%2C%20soft%20boho%20minimalist%20interior%2C%20relaxed%20productive%20atmosphere%2C%20lifestyle%20editorial%20photography%20with%20organic%20textures&width=800&height=600&seq=whatis-img-v4&orientation=landscape&nocache=true"
                alt="Basetao Spreadsheet with fashion products organized on desk"
                className="w-full h-64 md:h-80 object-cover object-top"
              />
            </div>
          </div>

          <div className="order-2 md:order-2">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary-50 rounded-full mb-4">
              <div className="w-3.5 h-3.5 flex items-center justify-center text-primary-500">
                <i className="ri-information-line text-xs"></i>
              </div>
              <span className="text-xs font-medium text-primary-700">About Basetao Spreadsheet</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4 leading-tight">
              What Is Basetao Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              <strong>Basetao Spreadsheet</strong> is a powerful organization system designed specifically for international shoppers who use Basetao as their purchasing agent. It helps users manage products, orders, warehouse information, shipping calculations, and budgeting workflows in one structured format.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Instead of manually tracking multiple purchases across different seller platforms, delivery windows, and shipping carriers, users can organize every piece of important information in a single spreadsheet system. This approach eliminates confusion, reduces costly mistakes, and gives shoppers complete visibility into their entire purchasing pipeline from order to delivery.
            </p>
            <Link
              to="/article/what-is-basetao-spreadsheet"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              Learn More in Our Full Guide
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}